/**
 * The initialization state.
 */
export interface InitializeState {
	/**
	 * If we're fully initialized.
	 */
	initialized: boolean;
	/**
	 * If the application config has loaded.
	 */
	applicationConfigLoaded: boolean;
	/**
	 * If the default locales have loaded.
	 */
	defaultLocalesLoaded: boolean;
	/**
	 * If the default global locales loaded (used for /invalid).
	 */
	defaultGlobalLocalesLoaded: boolean;
	/**
	 * If the environment data has loaded.
	 */
	environmentLoaded: boolean;
	/**
	 * If the merchant information has loaded.
	 */
	merchantLoaded: boolean;
}

/**
 * Our default initialization state.
 */
export const initialState: InitializeState = {
	initialized: false,
	applicationConfigLoaded: false,
	defaultLocalesLoaded: false,
	defaultGlobalLocalesLoaded: false,
	environmentLoaded: false,
	merchantLoaded: false,
};
